import { makeObservable, observable, action } from "mobx";

import {
  BalanceLimitResponse,
  BalanceTransactionRequestData,
  GetBalanceHistoryRequest
} from "../models/managerResponse";
import { HttpResponse, managerController } from "../api";
import { DEFAULT_RESPONSE_LIST } from "../constants";
import { RootStore } from ".";

export class ManagerStore {
  private rootStore?: RootStore;

  public errorMessageForManagerBalance: null | string = "";

  isShowSuccessesPart: boolean = false;

  public balanceLimitData = new HttpResponse<BalanceLimitResponse>(
    DEFAULT_RESPONSE_LIST,
  );

  constructor(rootStore?: RootStore) {
    this.rootStore = rootStore;
    makeObservable(this, {
      balanceLimitData: observable,
      isShowSuccessesPart: observable,
      errorMessageForManagerBalance: observable,
      setIsShowSuccessesPart: action.bound,
      setBalanceLimitHistory: action.bound,
      setErrorMessageForManagerBalance: action.bound,
    });
  }

  public async balanceTransaction(data: BalanceTransactionRequestData) {
    try {
      const response = await managerController.balanceTransaction(data);
      this.isShowSuccessesPart = true;
      return response;
    } catch (err: any) {
       this.errorMessageForManagerBalance = err.errorMessage;
    }
  }

  public async cashInBalance(data: BalanceTransactionRequestData) {
    try {
      const response = await managerController.cashInBalance(data);
      this.isShowSuccessesPart = true;
      return response;
    } catch (err: any) {
       this.errorMessageForManagerBalance = err.errorMessage;
    }
  }

  public async cashOutBalance(data: BalanceTransactionRequestData) {
    try {
      const response = await managerController.cashOutBalance(data);
      this.isShowSuccessesPart = true;
      return response;
    } catch (err: any) {
       this.errorMessageForManagerBalance = err.errorMessage;
    }
  }

  setIsShowSuccessesPart(bool: boolean) {
    this.isShowSuccessesPart = bool;
  }

  public setErrorMessageForManagerBalance(arg: null | string) {
    this.errorMessageForManagerBalance = arg;
  }

  public setBalanceLimitHistory(value: HttpResponse<BalanceLimitResponse>): void {
    this.balanceLimitData = value;
  }

  public async getBalanceHistory(params: GetBalanceHistoryRequest): Promise<void> {
    this.setBalanceLimitHistory(this.balanceLimitData.fetching());
    const result = await managerController.getBalanceHistory(params);
    this.setBalanceLimitHistory(this.balanceLimitData.fetched(result));
  }

  public async getLimitHistory(params: GetBalanceHistoryRequest): Promise<void> {
    this.setBalanceLimitHistory(this.balanceLimitData.fetching());
    const result = await managerController.getLimitHistory(params);
    this.setBalanceLimitHistory(this.balanceLimitData.fetched(result));
  }
}
